import { action } from "satcheljs";

const resetChangeStore = action(
    "resetChangeStore", () => ({})
);

export default resetChangeStore;
